import { render, staticRenderFns } from "./DocsDoNot.vue?vue&type=template&id=11c9ccf9&scoped=true&"
import script from "./DocsDoNot.vue?vue&type=script&lang=js&"
export * from "./DocsDoNot.vue?vue&type=script&lang=js&"
import style0 from "./DocsDoNot.vue?vue&type=style&index=0&id=11c9ccf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9ccf9",
  null
  
)

export default component.exports